import ButtonA from './ButtonA'

const ButtonC = ButtonA.extend`
  background: ${props => (props.disabled ? '#cccccc' : 'transparent')};
  color: ${props => (props.disabled ? '#ffffff' : '#444444')};
  border: 2px solid #cccccc;

  &:before {
    content: none;
  }

  &:hover {
    border: 2px solid #cccccc;
    background: #cccccc;
    box-shadow: none;
  }
`

export default ButtonC



// WEBPACK FOOTER //
// ./src/components/typography/buttons/ButtonC.js